import React from "react";
import MyTitle from "../myTitle";
import styleObj from "./style.module.scss";
import Invitation2021 from "./2021";

const getStand = (routeName) => {
  switch (routeName) {
    case "hangzhou":
      return "杭州";
    case "changsha":
      return "长沙";
    case "beijing":
      return "北京";
    case "qingdao":
      return "青岛";
    case "chengdu":
      return "成都";
    case "shanghai":
      return "上海";
  }
};

export default function Invitation(props) {
  let { list, routeName, meta } = props;
  return (
    !!list.length && (
      <>
        {meta?.is2021 ? (
          <Invitation2021 {...props} />
        ) : (
          <div className={styleObj["Invitation-wrap"]}>
            <MyTitle
              mainTitle={`${getStand(routeName)}站·跨界品鉴官`}
              subTitle="INVITATION"
            />
            <ul className={styleObj["Invitation-list"]}>
              {list.map((item, i) => (
                <li key={i}>
                  <div className={styleObj["avatar"]}>
                    {/* <img src={require(`../../assets/imgs/${item.pic}`)} alt="" /> */}
                    <img src={`//s2.jiguo.com/${item.pic}`} alt="" />
                  </div>
                  <div className={styleObj["intro"]}>
                    <div className={styleObj["nickname"]}>{item.name}</div>
                    <div className={styleObj["desc"]}>
                      <p>{item.title}</p>
                      <p>{item.subTitle}</p>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    )
  );
}
